export default __webpack_public_path__ + "static/map-a724f7ea05b6ca19e103ea960fe00ed0.svg";